import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { toggleLoadingHandler } from '../../actions'
import { authorizeClient, oauth2_login } from "../../APIs"
import SignInBox from './signin';
import { getAuthParams } from "./utils";
import { getUrlVars } from '../../utils';

function SignIn({ toggleLoadingHandler }) {
    const [firstload, setFirstload] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(true)
    const history = useHistory();
    const { base_url, redirect_uri, code_challenge, code_challenge_method } = getAuthParams()

    useEffect(() => {
        if (firstload) {
            const temp = getUrlVars()["temp"];
            if (temp) {
                setIsLoggedIn(false);
            } else {
                checkSession();
            }
            setFirstload(false)
        }
    })

    async function checkSession() {
        toggleLoadingHandler(true)
        try {
            const code = await getAuthCode();
            redirectWithAuthCode(code);
        } catch(err) {
            setIsLoggedIn(false)
        }
        toggleLoadingHandler(false)
        async function getAuthCode(code) {
            await authorizeClient(base_url, code_challenge, code_challenge_method);
            const res = await oauth2_login(base_url, code_challenge, code_challenge_method);
            if (res.data.code) {
                return res.data.code;
            } else {
                throw("Failed to get authorization code")
            }
        }
        function redirectWithAuthCode(code) {
            window.location.href = insertCodeQueryParams(redirect_uri, code);
            // if (window.confirm("Already logged in. Ready to redirect?")) {
            //     window.location.href = insertCodeQueryParams(redirect_uri, code);
            // } else {
            //     setIsLoggedIn(false)
            // }

            function insertCodeQueryParams(urlStr, code) {
                let url = new URL(urlStr);
                let params = url.searchParams;
                params.append('code', code);
                return url.toString()
            }
        }
    }

    return (
        <div>
        {isLoggedIn ? null :
            <SignInBox />
        }
        </div>
    )
}

const mapStateToProps = state => ({ 

});

const mapDispatchToProps = { toggleLoadingHandler }

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);